import { z } from "zod";
export const DTODocumentationMinimalPage = z.object({
    id: z.string(),
    title: z.string(),
    fullPath: z.string(),
    description: z.string().optional(),
});
export const DTODocumentationContent = z.object({
    id: z.string(),
    markdown: z.string(),
});
export const DTODocumentationMinimalPageListResponse = z.object({
    pages: z.array(DTODocumentationMinimalPage),
});
export const DTODocumentationContentResponse = z.object({
    pageContents: z.array(DTODocumentationContent),
});
export const DTODocumentationContentQuery = z.object({
    pageIds: z
        .string()
        .transform((value) => value.split(","))
        .pipe(z.string().trim().array()),
});
